import { useEffect, useState } from 'react'
import Screen from '../../components/Screen';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import checklistCollectionVideo from "../../assets/Spilited/ChecklistCollection.mp4"
import raCollectionVideo from "../../assets/Spilited/RACollection.mp4"
import addChecklistVideo from "../../assets/Spilited/AddCheckList.mp4"
import addRaVideo from "../../assets/Spilited/addNewRAmp4.mp4"
import auditVideo from "../../assets/Spilited/auditCollection.mp4"
import addAuditVideo from "../../assets/Spilited/addNewAudit.mp4"
import policiesVideo from "../../assets/Spilited/policiesCollection.mp4"
import addPoliciesVideo from "../../assets/Spilited/addNewPolicy.mp4"
import formVideo from "../../assets/Spilited/formCollection.mp4"
import addFormVideo from "../../assets/Spilited/addNewForm.mp4"
import agreementsVideo from "../../assets/Spilited/agreementList.mp4"
import addAgreementsVideo from "../../assets/Spilited/addNewAgreement.mp4"
import recordsVideo from "../../assets/Spilited/records.mp4"
import tasksVideo from "../../assets/Spilited/tasks.mp4"
import documentLibraryVideo from "../../assets/Spilited/documentLibrary.mp4"
import publicLibraryVideo from "../../assets/Spilited/publicLibrary.mp4"
import msVideo from "../../assets/Spilited/managementSystem.mp4"
import sitesVideo from "../../assets/Spilited/sites.mp4"
import subscriptionVideo from "../../assets/Spilited/subscription.mp4"
import paymentMethodVideo from "../../assets/Spilited/paymentMethod.mp4"
import inboxVideo from "../../assets/Spilited/inbox.mp4"
import emailsVideo from "../../assets/Spilited/emailDatabase.mp4"
import emailConfirmationsVideo from "../../assets/Spilited/emailConfirmations.mp4"
import sentMailssVideo from "../../assets/Spilited/sentMails.mp4"
import pendingMailsVideo from "../../assets/Spilited/pendingMails.mp4"
import profileVideo from "../../assets/Spilited/profile-final.mp4"
import ticketsVideo from "../../assets/Spilited/ticket.mp4"
export default function Default() {
    const [loading, setLoading] = useState(false)
    let list = [
        {
            id: "checklist_id",
            title: "Checklists",
            url: checklistCollectionVideo
        },
        {
            id: "add_checklist_id",
            title: "Add Checklist",
            url: addChecklistVideo
        },
        {
            id: "risk_assessments_id",
            title: "Risk Assessments",
            url: raCollectionVideo
        },
        {
            id: "add_risk_assessments_id",
            title: "Add Risk Assessment",
            url: addRaVideo
        },
        {
            id: "audit_id",
            title: "Audits",
            url: auditVideo
        },
        {
            id: "add_audit_id",
            title: "Add Audit",
            url: addAuditVideo
        },
        {
            id: "policies_id",
            title: "Policies",
            url: policiesVideo
        },
        {
            id: "add_policy_id",
            title: "Add Policy",
            url: addPoliciesVideo
        },
        {
            id: "forms_id",
            title: "Forms",
            url: formVideo
        },
        {
            id: "add_forms_id",
            title: "Add Form",
            url: addFormVideo
        },
        {
            id: "agreements_id",
            title: "Agreements",
            url: agreementsVideo
        },
        {
            id: "add_agreements_id",
            title: "Add Agreement",
            url: addAgreementsVideo
        },
        {
            id: "records_id",
            title: "Records",
            url: recordsVideo
        },
        {
            id: "tickets_id",
            title: "Tickets",
            url: ticketsVideo
        },
        {
            id: "tasks_id",
            title: "Tasks",
            url: tasksVideo
        },
        {
            id: "document_library_id",
            title: "Document Library",
            url: documentLibraryVideo
        },
        {
            id: "public_library_id",
            title: "Public Library",
            url: publicLibraryVideo
        },
        {
            id: "management_system_id",
            title: "Management System",
            url: msVideo
        },
        {
            id: "sites_id",
            title: "Sites",
            url: sitesVideo
        },
        {
            id: "subscriptions_id",
            title: "Subscription",
            url: subscriptionVideo
        },
        {
            id: "payment_methods_id",
            title: "Payment Methods",
            url: paymentMethodVideo
        },
        {
            id: "inbox_id",
            title: "Inbox",
            url: inboxVideo
        },
        {
            id: "emails_id",
            title: "Email Database",
            url: emailsVideo
        },
        {
            id: "email_confirmations_id",
            title: "Email Confirmations",
            url: emailConfirmationsVideo
        },
        {
            id: "sent_emails_id",
            title: "Pending Confirmations",
            url: sentMailssVideo
        },
        {
            id: "pending_mails_id",
            title: "Pending Mails",
            url: pendingMailsVideo
        },
        {
            id: "profile_id",
            title: "Profile",
            url: profileVideo
        },
    ]
    const location = useLocation()
    const [targetId, setTargetId] = useState(location.state?.id || 'checklist'); // Example: id from state
    useEffect(() => {
        if (targetId) {
            const element = document.getElementById(`${targetId}_id`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [targetId]); // Runs when targetId is set/updated
    useEffect(() => {
      if(location.state){
        setTargetId(location?.state?.id)
      }
    }, [location])
    
    return (
        <Screen
            loading={loading == "initial"}
            flow={[
                { label: `FAQ's`, to: `/faqs` },
                { label: "Home", to: "/" },
                { label: `FAQ's`, to: `/faqs` },
            ]}>
            {list?.map((item, index) => (
                <div style={{ paddingTop: '60px' }} key={index} id={item.id}>
                    <center><Typography variant='h4'>{item.title}</Typography></center>
                    <br />
                    <center>
                        <Box sx={{
                            width: {
                                xs: '100%',
                                sm: '100%',
                                md: '80%',
                                lg: '80%',
                            }
                        }}>
                            <video style={{ boxShadow: '0px 0px 10px', position: 'relative' }} width="100%" height="440" controls>
                                <source src={item.url} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </Box>
                    </center>
                </div>
            ))}
        </Screen>
    )
}
